export enum AccountModalActions {
  setCallbackFunction = 'setCallbackFunction',
}

type IAccountModalAction = { type: AccountModalActions.setCallbackFunction; payload?: () => void };

export interface IAccountModalState {
  callbackFunction: () => void | null;
}

export const INITIAL_ACCOUNT_MODAL_STATE: IAccountModalState = {
  callbackFunction: null,
};

export const accountModalReducer = (state: IAccountModalState, action: IAccountModalAction) => {
  switch (action.type) {
    case AccountModalActions.setCallbackFunction:
      state.callbackFunction = action?.payload;
      break;

    default:
      return state;
  }
  return state;
};
